import React from 'react';
import { Button, Box, Modal } from '@mui/material';
import Game from './Game';

export default function GameModal({ open, onClose }) {
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: 'absolute', top: '50%', left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper', p: 2, boxShadow: 24
        }}
      >
        <Button
          onClick={onClose}
          sx={{
            position: 'absolute', top: 8, right: 8,
            bgcolor: 'error.main', color: '#fff'
          }}
        >
          Close
        </Button>
        <Game />
      </Box>
    </Modal>
  );
}
